import { ValidationErrors } from '@/entities/validation';
import { ApiError } from '@/services/api';
import { validationError } from '@/ui/dictionary';
import { localeFormat, parseInt10, toastWithClickOutside } from '@/ui/helpers';
import { t } from '@/ui/i18n/i18n';

const MAX_ERRORS = 10;

export const useValidationErrors = () => {
  const formatErrorMessage = (errors: ValidationErrors) => {
    const messages = errors.slice(0, MAX_ERRORS).map(error => {
      switch (error.type) {
        case 'required':
          return t('entity-item.upload-modal.validation.required', {
            row: error.parameters[0],
            field: t(`entity-item.upload-modal.fields.${error.field}`),
          });

        case 'notFound':
          return t('entity-item.upload-modal.validation.not-found', {
            id: error.parameters[1],
          });

        case 'exists':
          return t('entity-item.upload-modal.validation.exists', {
            row: error.parameters[0],
            emails: error.parameters.slice(1).join(', '),
          });

        case 'maxFile':
          return t('entity-item.upload-modal.validation.maxFile', {
            size: error.parameters[0],
          });

        case 'excelMaxRows':
          return t('entity-item.upload-modal.validation.excelMaxRows', {
            rows: localeFormat(parseInt10(error.parameters[0])),
          });

        case 'multipleValuesNotAllowed':
          return t('entity-item.upload-modal.validation.multipleValuesNotAllowed', {
            row: error.parameters[0],
            field: error.parameters[1],
          });

        case 'invalidOptionValue':
          return t('entity-item.upload-modal.validation.invalidOptionValue', {
            row: error.parameters[0],
            field: error.parameters[1],
          });

        case 'duplicateId':
          return t('entity-item.upload-modal.validation.duplicateId', {
            row: error.parameters[0],
            field: error.parameters[1],
          });

        case 'typeMismatch':
          return t('entity-item.upload-modal.validation.typeMismatch', {
            currentType: error.parameters[1],
          });

        default:
          return validationError(error.field, error);
      }
    });

    return messages.join('\n');
  };

  const displayValidationErrors = (e: ApiError) => {
    toastWithClickOutside(formatErrorMessage(e.messages), {
      type: 'error',
      duration: 0,
      className: 'show-newlines',
      action: {
        text: t('common.close'),
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      },
    });
  };

  return {
    displayValidationErrors,
  };
};
